import { COMMERCIAL_PERIODS } from '../pages/comercial/commercialPeriods.js'

const iso = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
const windowRange = (now, days, offset = 0) => {
  const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - offset)
  const start = new Date(end.getFullYear(), end.getMonth(), end.getDate() - days + 1)
  return { from: iso(start), to: iso(end) }
}
export const REPORT_PERIODS = [
  { id: 'hoje', label: 'Hoje', range: now => windowRange(now, 1) },
  { id: 'ontem', label: 'Ontem', range: now => windowRange(now, 1, 1) },
  ...[7, 14, 30, 60, 90].map(days => ({ id: `dias_${days}`, label: `Últimos ${days} dias`, range: now => windowRange(now, days) })),
  ...COMMERCIAL_PERIODS,
]
